export default __webpack_public_path__ + "2c7fbcbb5179283ff6334b510274ee7a.svg";